import { useStatusBarStyle } from '@euler/app/components/AppStatusBar';
import { StatusColors } from '@euler/components/Colors';
import { useCallback } from 'react';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
} from 'react-native-reanimated';
import { WebView } from 'react-native-webview';

export type EmbeddedWebViewProps = {
  uri: string;
  title: string;
};

const EmbeddedWebView = (props: EmbeddedWebViewProps) => {
  useStatusBarStyle('dark');

  const width = useSharedValue(0);
  const progress = useSharedValue(0);
  const progressStyle = useAnimatedStyle(() => ({
    opacity: width.value ? 1 : 0,
    transform: [{ translateX: (progress.value - 1) * width.value }],
  }));

  const onWebViewLoad = useCallback(() => {
    progress.value = 0;
  }, [progress]);

  return (
    <>
      <WebView
        source={{
          uri: props.uri,
        }}
        onLoadProgress={e => (progress.value = e.nativeEvent.progress)}
        onLoad={onWebViewLoad}
        onError={() => (progress.value = 0)}
      />
      <Animated.View
        css={`
          height: 3px;
          background-color: ${StatusColors.Info};
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
        `}
        style={progressStyle}
        onLayout={e => (width.value = e.nativeEvent.layout.width)}
      />
    </>
  );
};

export default EmbeddedWebView;
